const state = {
    saving: false,
    loading: null,
    dirty: false
}

const mutations = {
    SET_SAVING (state, value) {
        state.saving = value
    },
    SET_LOADING (state, value) {
        state.loading = value
    },
    SET_DIRTY (state, value) {
        state.dirty = value
    }
}

const actions = {
    setSaving ({commit, dispatch}, value) {
        commit('SET_SAVING', value)
    },
    setLoading ({commit, dispatch}, value) {
        commit('SET_LOADING', value)
    },
    setDirty ({commit}, value) {
        commit('SET_DIRTY', value)
    }
}

const getters = {
    saving: (state) => {
        return state.saving
    },
    loading: (state) => {
        return state.loading
    },
    dirty: (state) => {
        return state.dirty
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
